import { useState } from 'react';
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Process from "./components/Process";
import Cases from "./components/Cases";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FaqSection";
import Inquiry from "./components/Inquiry";
import SnsLinks from "./components/SnsLinks";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";
import Intro from "./components/Intro";

export default function Home() {
  const [introDone, setIntroDone] = useState(false);

  return (
    <div className="min-w-0 lg:min-w-[1024px] bg-background-50 text-foreground-950">
      {!introDone && <Intro onComplete={() => setIntroDone(true)} />}
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Process />
        <Cases />
        <Testimonials />
        <FaqSection />
        <SnsLinks />
        <Inquiry />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}